import HubMetrifyEvent from '@hotmart/event-agent-js/dist/models/hub-metrify-event'
import { DataLayer } from 'src/utils/google-analytics'

export enum MENU_GROUP_COLORS {
  browse = 'blue',
  discover = 'purple',
  extensions = 'cyan'
}

export type MenuItem = {
  title: string
  route: Function | string
  icon: string
  testid?: string
  isBeta?: boolean
  dataLayerEvents: DataLayer[]
  dataHubEvents: Pick<HubMetrifyEvent, 'group' | 'name'>[]
}
